(() => {
  if (document.documentElement.dataset.k9Natural2026Bound === 'true') return;
  document.documentElement.dataset.k9Natural2026Bound = 'true';
  document.addEventListener('click', (event) => {
    const lineupLink = event.target.closest('.k9-natural2026__fixed-link, [data-k9-n26-anchor]');
    if (lineupLink && lineupLink.origin === location.origin && lineupLink.pathname === location.pathname && lineupLink.hash) {
      const target = document.getElementById(lineupLink.hash.slice(1));
      if (target) {
        event.preventDefault();
        event.stopPropagation();
        target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
      }
      return;
    }
    const guideClose = event.target.closest('[data-k9-guide-close]');
    if (guideClose) {
      guideClose.closest('details')?.removeAttribute('open');
      return;
    }

    const button = event.target.closest('[data-k9-video-id]');
    if (!button || button.dataset.loaded === 'true') return;
    const videoId = button.dataset.k9VideoId;
    if (!/^[\w-]{6,20}$/.test(videoId)) return;
    const iframe = document.createElement('iframe');
    iframe.src = `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0&playsinline=1`;
    iframe.title = '動画を再生';
    iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
    iframe.allowFullscreen = true;
    button.dataset.loaded = 'true';
    button.replaceChildren(iframe);
  }, { capture: true });

  const sections = new Set();
  let frameRequested = false;

  const backgroundVideos = new Map();
  const mobileVideo = window.matchMedia('(max-width: 576px)');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const syncBackgroundVideo = (video, visible) => {
    if (!visible || document.hidden || reducedMotion.matches) {
      video.pause();
      return;
    }
    const source = mobileVideo.matches ? video.dataset.srcSp : video.dataset.srcPc;
    if (!source) return;
    if (video.getAttribute('src') !== source) {
      video.src = source;
      video.load();
    }
    video.muted = true;
    if (video.paused) {
      video.play().then(() => {
        if (!backgroundVideos.get(video) || document.hidden || reducedMotion.matches) video.pause();
      }).catch(() => {
        // Keep the poster visible when the device blocks automatic playback.
      });
    }
  };
  const backgroundObserver = new IntersectionObserver((entries) => {
    entries.forEach(({ target, isIntersecting }) => {
      backgroundVideos.set(target, isIntersecting);
      syncBackgroundVideo(target, isIntersecting);
    });
  });
  const syncBackgroundVideos = () => backgroundVideos.forEach((visible, video) => syncBackgroundVideo(video, visible));
  mobileVideo.addEventListener('change', syncBackgroundVideos);
  reducedMotion.addEventListener('change', syncBackgroundVideos);
  document.addEventListener('visibilitychange', syncBackgroundVideos);

  const update = () => {
    frameRequested = false;
    const viewportHeight = window.innerHeight;
    document.querySelectorAll('[data-k9-n26-bar]').forEach((bar) => {
      const firstSection = document.querySelector('[data-k9-natural2026]');
      const visible = Boolean(firstSection && firstSection.getBoundingClientRect().top < -200);
      bar.classList.toggle('is-visible', visible);
      bar.inert = !visible;
    });

    sections.forEach((section) => {
      if (!section.isConnected) {
        sections.delete(section);
        return;
      }

      const rect = section.getBoundingClientRect();
      const progress = Math.max(0, Math.min(1, -rect.top / section.offsetHeight));
      const inView = rect.bottom > 0 && rect.top < viewportHeight;
      let brightness = 1;
      let overlayOpacity = 0;
      let contentOpacity = 0;

      if (inView && progress >= 0.2 && progress < 0.4) {
        const phase = (progress - 0.2) / 0.2;
        brightness = 1 - 0.45 * phase;
        overlayOpacity = phase;
        contentOpacity = 1;
      } else if (inView && progress >= 0.4 && progress < 0.6) {
        brightness = 0.55;
        overlayOpacity = 1;
        contentOpacity = 1;
      } else if (inView && progress >= 0.6) {
        const phase = (progress - 0.6) / 0.4;
        brightness = 0.55 + 0.45 * phase;
        overlayOpacity = 1 - phase;
        contentOpacity = 1 - Math.max(0, (phase - 0.3) / 0.7);
      }

      section.querySelectorAll('.k9-natural2026__nz-video, .k9-natural2026__nz-media-inner > picture img').forEach((media) => {
        media.style.filter = `brightness(${brightness})`;
      });
      const overlay = section.querySelector('.k9-natural2026__nz-overlay');
      const content = section.querySelector('.k9-natural2026__nz-content');
      if (overlay) overlay.style.opacity = String(overlayOpacity);
      if (content) {
        content.classList.toggle('is-visible', contentOpacity > 0);
        content.style.opacity = String(contentOpacity);
      }
    });
  };

  const requestUpdate = () => {
    if (frameRequested) return;
    frameRequested = true;
    window.requestAnimationFrame(update);
  };

  // The backdrop spans separate CMS sections; resizing content keeps its curve aligned.
  const layoutOvenBaked = () => {
    const intro = document.querySelector('[data-k9-n26-ov-intro]');
    const end = document.querySelector('[data-k9-n26-ov-end]');
    if (intro && end) {
      const padding = parseFloat(getComputedStyle(end).paddingBottom);
      const height = end.getBoundingClientRect().bottom - intro.getBoundingClientRect().top - padding;
      intro.style.setProperty('--k9-ov-content-height', `${height}px`);
    }
    const bar = document.querySelector('[data-k9-n26-bar]');
    const footer = document.querySelector('.k9-natural2026__footer');
    if (footer) footer.style.setProperty('--k9-ov-bar-height', `${bar?.offsetHeight || 0}px`);
  };
  const ovenResizeObserver = new ResizeObserver(layoutOvenBaked);
  const init = (root = document) => {
    backgroundVideos.forEach((visible, video) => {
      if (!video.isConnected) {
        video.pause();
        backgroundObserver.unobserve(video);
        backgroundVideos.delete(video);
      }
    });
    root.querySelectorAll('[data-k9-background-video]').forEach((video) => {
      if (backgroundVideos.has(video)) return;
      backgroundVideos.set(video, false);
      backgroundObserver.observe(video);
    });
    root.querySelectorAll('[data-k9-natural2026-nz]').forEach((section) => sections.add(section));
    ovenResizeObserver.disconnect();
    if (document.querySelector('[data-k9-n26-ov-intro]')) {
      document.querySelectorAll('#MainContent > .shopify-section, [data-k9-n26-bar]').forEach((section) => ovenResizeObserver.observe(section));
      layoutOvenBaked();
    }
    requestUpdate();
  };

  init();
  // Capture also handles Fabric's scrolling wrapper after it is re-rendered.
  document.addEventListener('scroll', requestUpdate, { passive: true, capture: true });
  window.addEventListener('resize', () => { requestUpdate(); layoutOvenBaked(); });
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', () => requestAnimationFrame(() => init()));
  document.addEventListener('shopify:section:reorder', layoutOvenBaked);
  document.fonts.ready.then(layoutOvenBaked);
})();
